export default __webpack_public_path__ + "static/media/power_by_header_new.d91a576a.svg";